import { RouteRecordRaw } from "vue-router";

import Servizi from './pages/service.vue';

const routes: RouteRecordRaw[] = [
    {
        path: '/service',
        component: Servizi,
        meta: { 
            requiresAuth: true,
            menu: {
                order: 5,
                label: 'Servizi',
                iconAsset: 'icons/ico-servizi.svg'
            }
        }
    }
];

export default routes;